// Penyunting Word manual: utiliti DOM (setiap perenggan = satu kawasan contentEditable berasingan).
export const KEYS = ["b", "i", "u", "sz", "f", "c", "h"];

const enc = (k, v) => (k === "b" || k === "i" || k === "u" ? (v ? "1" : "0") : v == null ? "" : String(v));
const dec = (k, v) => (k === "b" || k === "i" || k === "u" ? v === "1" : k === "sz" ? parseFloat(v) : k === "h" ? v || null : v);

export function styleSpan(span, fmt) {
  span.style.fontWeight = fmt.b ? "700" : "400";
  span.style.fontStyle = fmt.i ? "italic" : "normal";
  span.style.textDecoration = fmt.u ? "underline" : "none";
  span.style.fontSize = `${fmt.sz}pt`;
  span.style.fontFamily = `"${fmt.f}"`;
  span.style.color = `#${fmt.c}`;
  span.style.backgroundColor = fmt.h ? `#${fmt.h}` : "transparent";
}

function makeSpan(fmt, r, node) {
  const s = document.createElement("span");
  s.dataset.r = r == null ? "" : String(r);
  KEYS.forEach((k) => { s.dataset[k] = enc(k, fmt[k]); });
  styleSpan(s, fmt);
  s.appendChild(node);
  return s;
}

export function buildPara(block, dflt) {
  const p = document.createElement("p");
  p.className = "wed-p";
  p.dataset.pid = String(block.pid);
  p.dataset.align = block.align;
  p.style.textAlign = block.align;
  if (block.indent?.left) p.style.paddingLeft = `${block.indent.left}pt`;
  if (block.indent?.first) p.style.textIndent = `${block.indent.first}pt`;
  const first = block.runs[0];
  p.dataset.def = JSON.stringify({ r: first ? first.r : null, ...(first ? Object.fromEntries(KEYS.map((k) => [k, first[k]])) : dflt) });
  if (block.prefix) {
    const pre = document.createElement("span");
    pre.contentEditable = "false";
    pre.dataset.prefix = "1";
    pre.className = "wed-prefix";
    pre.textContent = `${block.prefix} `;
    p.appendChild(pre);
  }
  if (block.locked) {
    p.contentEditable = "false";
    p.classList.add("wed-locked");
    p.title = "Perenggan ini ada gambar/medan/pautan - dikekalkan asal, tidak boleh disunting di sini";
    p.appendChild(document.createTextNode(block.text || ""));
    return p;
  }
  p.contentEditable = "true";
  p.spellcheck = false;
  block.runs.forEach((r) => p.appendChild(makeSpan(r, r.r, document.createTextNode(r.text))));
  return p;
}

function textNodes(host) {
  const out = [];
  const w = document.createTreeWalker(host, NodeFilter.SHOW_TEXT | NodeFilter.SHOW_ELEMENT, {
    acceptNode: (n) => (n.nodeType === 1 && n.dataset?.prefix ? NodeFilter.FILTER_REJECT : NodeFilter.FILTER_ACCEPT),
  });
  let n = w.nextNode();
  while (n) {
    const lastBr = n.nodeName === "BR" && !n.nextSibling && (n.parentNode === host || !n.parentNode.nextSibling);
    if (n.nodeType === 3 || (n.nodeName === "BR" && !lastBr)) out.push(n);
    n = w.nextNode();
  }
  return out;
}

export function resolve(node, host) {
  const def = JSON.parse(host.dataset.def || "{}");
  const fmt = {};
  let el = node.nodeType === 3 ? node.parentElement : node.parentElement;
  while (el) {
    if (el.dataset) {
      if (!("r" in fmt) && el.dataset.r !== undefined) fmt.r = el.dataset.r === "" ? null : parseInt(el.dataset.r, 10);
      KEYS.forEach((k) => { if (!(k in fmt) && el.dataset[k] !== undefined) fmt[k] = dec(k, el.dataset[k]); });
    }
    if (el === host) break;
    el = el.parentElement;
  }
  return { ...def, ...fmt };
}

export function serialize(host) {
  const runs = [];
  textNodes(host).forEach((n) => {
    const text = n.nodeType === 3 ? n.nodeValue : "\n";
    if (!text) return;
    const f = resolve(n, host);
    const last = runs[runs.length - 1];
    if (last && last.r === f.r && KEYS.every((k) => last[k] === f[k])) last.text += text;
    else runs.push({ text, r: f.r, ...Object.fromEntries(KEYS.map((k) => [k, f[k]])) });
  });
  return { pid: parseInt(host.dataset.pid, 10), align: host.dataset.align, runs };
}

function flatten(host) {
  const items = textNodes(host).map((n) => {
    const f = resolve(n, host);
    return { node: n.nodeType === 3 ? n : document.createTextNode("\n"), f };
  });
  [...host.childNodes].forEach((c) => { if (!c.dataset?.prefix) host.removeChild(c); });
  items.forEach(({ node, f }) => host.appendChild(makeSpan(f, f.r, node)));
}

// Pilihan semasa -> nod teks terpilih (dipecah tepat di sempadan pilihan)
function selectedTexts(range, host) {
  const nodes = textNodes(host).filter((n) => n.nodeType === 3 && range.intersectsNode(n));
  const { startContainer: sc, startOffset: so, endContainer: ec, endOffset: eo } = range;
  return nodes.map((n) => {
    const s = n === sc ? so : 0;
    const e = n === ec ? eo : n.length;
    if (s >= e) return null;
    let t = n;
    if (e < t.length) t.splitText(e);
    if (s > 0) t = t.splitText(s);
    return t;
  }).filter(Boolean);
}

export function hostOf(node, root) {
  const el = node?.nodeType === 3 ? node.parentElement : node;
  const h = el?.closest?.("[data-pid]");
  return h && root.contains(h) && h.contentEditable === "true" ? h : null;
}

/** Terapkan format pada pilihan. value=undefined untuk togol (b/i/u). Pulang true jika berjaya. */
export function applyFmt(range, root, key, value) {
  const host = hostOf(range.commonAncestorContainer, root);
  if (!host || range.collapsed) return false;
  const texts = selectedTexts(range, host);
  if (!texts.length) return false;
  const v = value === undefined ? !texts.every((t) => resolve(t, host)[key]) : value;
  texts.forEach((t) => {
    const s = document.createElement("span");
    s.dataset[key] = enc(key, v);
    t.parentNode.insertBefore(s, t);
    s.appendChild(t);
  });
  flatten(host);
  const sel = window.getSelection();
  const r = document.createRange();
  r.setStart(texts[0], 0);
  r.setEnd(texts[texts.length - 1], texts[texts.length - 1].length);
  sel.removeAllRanges();
  sel.addRange(r);
  return true;
}

export function setAlign(host, align) {
  host.dataset.align = align;
  host.style.textAlign = align;
}
